module.exports = __webpack_public_path__ + "img/rightarrow.c0d2890a.svg";